export default __webpack_public_path__ + "static/media/grity-power-logo.66c58762.png";